import { useCallback } from 'react';
import { useAuth } from '../context/AuthContext';
import { translations, getTranslation } from '../i18n/translations';

export const useTranslation = () => {
  const { user } = useAuth();
  const lang = user?.language || 'fr';
  
  const t = useCallback((path, params = {}) => {
    let text = getTranslation(lang, path);
    
    // Replace parameters like {count}, {months} etc.
    if (typeof text === 'string' && Object.keys(params).length > 0) {
      Object.entries(params).forEach(([key, value]) => {
        text = text.replace(new RegExp(`\\{${key}\\}`, 'g'), value);
      });
    }
    
    return text;
  }, [lang]);
  
  return { t, lang, translations: translations[lang] || translations.fr };
};

export default useTranslation;
